<div>
    <img class="img-fluid lijst" src="../../assets/img/foto_frame.png">
    <div class="foto-in-lijst" [ngStyle]="{'background-image': 'url(/assets/img/fotos/'+foto+')'}"></div>
    <div class="foto-name">{{getFotoName(foto)}}</div>
</div>